import { render, staticRenderFns } from "./SmsListDialog.vue?vue&type=template&id=20971728&scoped=true&"
import script from "./SmsListDialog.vue?vue&type=script&lang=js&"
export * from "./SmsListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20971728",
  null
  
)

export default component.exports